import styled from "styled-components/macro";

export default styled.div`
text-align:center;
.MuiGrid-item {
  padding: 12px 10px !important;
}
`;
